/**
 * @name 헤더
 * @description
 */
import {Text} from 'lib'
import {useEffect} from 'react'
import styled from 'styled-components'
import {COLOR} from 'styles'
// contents
import AddBankButton from './add-bank'

export default function Contents() {
  // hooks
  //*--------------------------------------------------*
  useEffect(() => {}, [])
  //*--------------------------------------------------*
  return (
    <Content>
      <Text mode="Headline_MB" color={COLOR.gray30}>
        장치 현황
      </Text>
      {/* Bank 추가 */}
      <AddBankButton />
    </Content>
  )
}
//*--------------------------------------------------*
const Content = styled.div`
  display: flex;
  width: 100%;
  height: 80px;
  padding: 0 24px;
  border-bottom: 1px solid ${COLOR.gray90};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
